import { Link } from "react-router"

import { ButtonLink } from "~/components/ui/button"
import { capture } from "~/client/posthog.client"

// Closing CTA band (Forest DS "Tagline block / End", Figma 8:450) + legal
// footer (Figma Footer 8:633). "id=book-a-call" is the anchor the hero and
// footer CTAs point at; wire it to the real booking flow (Calendly/HubSpot)
// when the destination is decided.
//
// `closingCta` is dropped on pages that ARE the band's destination
// (/get-started renders <DocsBanner> in its place instead). The legal strip
// below always renders.
export function Footer({ closingCta = true }: { closingCta?: boolean }) {
  return (
    <>
      {closingCta && (
        <section
          id="book-a-call"
          className="flex min-h-[474px] scroll-mt-20 flex-col items-center justify-center gap-2.5 bg-forest px-6 py-20 text-center"
        >
          <img
            src="/brand/logo-symbol-green.svg"
            alt=""
            width={102}
            height={42}
            loading="lazy"
            className="h-6 w-auto"
          />
          <h2 className="mt-4 max-w-[960px] font-sans text-[clamp(40px,7vw,80px)] font-normal leading-none tracking-[-0.05em] text-hay">
            Turn aggregated location intelligence into{" "}
            <span className="font-serif italic tracking-[-0.04em]">
              competitive advantage
            </span>
          </h2>
          <p className="mt-3 max-w-[640px] font-sans text-[20px] font-medium leading-tight tracking-[-0.4px] text-chartreuse">
            Discover how Pine59 can power your analytics, products and AI with
            statistical insights about places and populations.
          </p>
          <div className="mt-6">
            <ButtonLink
              href="/get-started"
              onClick={() =>
                capture("explore_data_clicked", { location: "footer" })
              }
            >
              Get access
            </ButtonLink>
          </div>
        </section>
      )}

      <footer className="border-t border-chartreuse bg-forest px-5 py-4">
        <div className="flex flex-col gap-4 md:flex-row md:items-center">
          <Link
            to="/"
            aria-label="Pine59 home"
            className="flex h-11 w-[100px] shrink-0 items-center"
          >
            <img
              src="/brand/logo-green.svg"
              width={176}
              height={50}
              alt="Pine59"
              loading="lazy"
              className="h-[18px] w-auto"
            />
          </Link>

          <div className="flex items-center gap-6">
            {/* Figma colors these forest-bottom (#66640F, "moss") on the dark
                ground, but moss on forest is ~2:1; chartreuse is 4.6:1 (AA). */}
            <ButtonLink
              href="/privacy"
              variant="text"
              surface="dark"
              className="text-chartreuse hover:text-hay"
            >
              Privacy Policy
            </ButtonLink>
            <ButtonLink
              href="/terms"
              variant="text"
              surface="dark"
              className="text-chartreuse hover:text-hay"
            >
              Terms of Service
            </ButtonLink>
          </div>

          <p className="flex-1 px-0 py-2.5 font-flex text-[14px] font-medium leading-none text-paper/70 md:px-6">
            © 2026 Pine59 · ↟ Founded among the pine trees of Norway · 59°N ↟
          </p>
        </div>
      </footer>
    </>
  )
}
